<template>
  <b-card class="p-0 bucket-scroll-card">
    <div class="bucket-scroll-container">
      <b-row>
        <b-col
          v-for="(b, i) in buckets"
          :key="i"
          cols="12"
          md="6"
          lg="4"
          class=""
        >
          <bucket-card
            :id="b.id"
            :name="b.name"
            :count="b.count"
            :bag-name="b.bag_name"
            :bag-count="b.bag_count"
            :device-ip="b.device_ip"
            :isdestination="b.is_leaf"
            :is-report="isReport"
            :sorting-string="sortingString"
          />
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard,
} from 'bootstrap-vue'
import BucketCard from './BucketCard.vue'

export default {
  components: {
    BucketCard,
    BRow,
    BCol,
    BCard,
  },
  props: {
    buckets: {
      type: Array,
      required: true,
    },
    isReport: {
      type: Boolean,
      required: true,
    },
    sortingString: {
      type: String,
      default: '',
    },
  },
}
</script>
<style>
/* .bucket-scroll-container {
  max-height: 260px;
  overflow-y: auto;
} */
</style>
